/**
 * Contact Us Form Interactive Handler
 */

export function initContactForm() {
	const form = document.getElementById("cyprus-contact-form");
	if (!form) return;

	const alertBox = document.getElementById("cyprus-contact-alert");
	const submitBtn = document.getElementById("cyprus-contact-submit-btn");

	const showAlert = (message, type = "success") => {
		if (!alertBox) return;
		alertBox.className = `cyprus-contact-form__alert cyprus-contact-form__alert--${type}`;
		alertBox.textContent = message;
		alertBox.style.display = "block";
		alertBox.scrollIntoView({ behavior: "smooth", block: "nearest" });
	};

	const hideAlert = () => {
		if (!alertBox) return;
		alertBox.style.display = "none";
		alertBox.textContent = "";
	};

	form.addEventListener("submit", async (e) => {
		e.preventDefault();
		hideAlert();

		const formData = new FormData(form);
		const name = formData.get("name")?.toString().trim();
		const email = formData.get("email")?.toString().trim();
		const subject = formData.get("subject")?.toString().trim();
		const message = formData.get("message")?.toString().trim();

		if (!name || !email || !subject || !message) {
			showAlert("Please fill in all required fields.", "error");
			return;
		}

		// Email format validation
		const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
		if (!emailRegex.test(email)) {
			showAlert("Please enter a valid email address.", "error");
			return;
		}

		// Prepare AJAX payload
		const ajaxUrl = window.cyprusContactSettings?.ajaxUrl || "/wp-admin/admin-ajax.php";
		const nonce = window.cyprusContactSettings?.nonce || "";

		formData.append("action", "cyprus_contact_form_submit");
		formData.append("nonce", nonce);

		// Loading state
		form.classList.add("cyprus-contact-form--loading");
		if (submitBtn) submitBtn.disabled = true;

		try {
			const response = await fetch(ajaxUrl, {
				method: "POST",
				body: formData,
			});

			const result = await response.json();

			if (result.success) {
				showAlert(result.data?.message || "Thank you! Your message has been sent.", "success");
				form.reset();
			} else {
				showAlert(result.data?.message || "An error occurred while sending your message. Please try again.", "error");
			}
		} catch (error) {
			showAlert("Network error. Please check your connection and try again.", "error");
		} finally {
			form.classList.remove("cyprus-contact-form--loading");
			if (submitBtn) submitBtn.disabled = false;
		}
	});
}